import { createRoot } from 'react-dom/client'
import { createOvermind } from 'overmind'
import { Provider as StateProvider } from 'overmind-react'

import App from 'src/App'

import { AppStateConfig } from 'src/state'

import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'

import 'src/theme/scss/index.scss'

const overmind = createOvermind(AppStateConfig, {
    devtools: true
})

//@TODO - React Strict Mode
createRoot(
    document.getElementById('root')!
).render(
    <>
        <StateProvider value={overmind}>
            <App />
        </StateProvider>
    </>
)
